import React from "react"

import {
    Card,
    CardBody,
    Row,
    Col,
    CardTitle,
    CardHeader,
} from "reactstrap"

import TitleWithBtn from "./Titles/TitleWithBtn"
const CardComponent = (props) => {

    return (
        <Card>
            {(!props.titleComponentWithBtn && props.title) && (
                <CardHeader>
                    <CardTitle tag="h5">{props.title}</CardTitle>
                    <hr />
                </CardHeader>
            )}
            {props.titleComponentWithBtn && (
                <CardHeader>
                    <TitleWithBtn title={props.title} button={props.button}/>
                    <hr />
                </CardHeader>
            )}
            <CardBody>
                {props.children}
            </CardBody>
        </Card>
    )
}

export default CardComponent